namespace GeniuzPOS.Member {
    export interface PsMemberGenderForm {
        MbGender: Serenity.StringEditor;
        MbGenderName: Serenity.StringEditor;
    }

    export class PsMemberGenderForm extends Serenity.PrefixedContext {
        static formKey = 'Member.PsMemberGender';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsMemberGenderForm.init)  {
                PsMemberGenderForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsMemberGenderForm, [
                    'MbGender', w0,
                    'MbGenderName', w0
                ]);
            }
        }
    }
}
